export default __webpack_public_path__ + "static/media/ArtFramesLG.d3efafd2.svg";